import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';
import { DietaryPreferencesEditor } from './DietaryPreferencesEditor';

interface DietaryPreferencesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Popup wrapper around DietaryPreferencesEditor — the same UI ProfilePage
 * renders as a section, reached from the home-feed prompt card. Closes itself
 * once the editor reports a successful save.
 */
export const DietaryPreferencesModal: React.FC<DietaryPreferencesModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation('profile');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <h2 className="mb-1 pr-8 text-lg font-bold text-foreground">{t('dietary.title')}</h2>
      <p className="mb-4 text-sm text-muted-foreground">{t('dietary.description')}</p>
      <DietaryPreferencesEditor onSaved={onClose} />
    </Modal>
  );
};
